import React from 'react';
import PropTypes from 'prop-types';
import { Image, Transformation } from 'cloudinary-react';
import { Cloudinary } from 'cloudinary-core';

const CloudImageComponent = (rawProps) => {
  const props = { ...CloudImageComponent.defaultProps, ...rawProps };
  const { transformation: transformationProps, ...rawImageProps } = props;
  const { getURL, ...imageProps } = rawImageProps; // getURL is one of our own props

  // Get a URL
  if (getURL) {
    const cloud = new Cloudinary({
      cloud_name: imageProps.cloud_name,
      responsive: imageProps.responsive,
    });

    const {
      // eslint-disable-next-line
      cloud_name, responsive, alt, ...urlProps
    } = imageProps;
    return cloud.url(props.publicId, {
      ...urlProps,
      transformation: props.transformation,
    });
  }

  // Get an image tag
  return (
    <Image {...imageProps}>
      <Transformation {...transformationProps} />
    </Image>
  );
};

CloudImageComponent.propTypes = {
  publicId: PropTypes.string.isRequired,
  alt: PropTypes.string,
  cloud_name: PropTypes.string,
  getURL: PropTypes.bool,
  responsive: PropTypes.bool,
  crop: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fetchFormat: PropTypes.string,
  dpr: PropTypes.string,
  quality: PropTypes.string,
  sizes: PropTypes.string,
  transformation: PropTypes.object,
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

CloudImageComponent.defaultProps = {
  cloud_name: process.env.REACT_APP_CLOUDINARY_NAME,
  alt: undefined,
  getURL: false,
  responsive: true,
  crop: 'scale',
  width: 'auto',
  height: undefined,
  fetchFormat: 'auto',
  dpr: 'auto',
  quality: 'auto:eco',
  sizes: '100vw',
  transformation: {
    flags: ['preserve_transparency', 'progressive'],
  },
  id: undefined,
  className: undefined,
  style: undefined,
};

export default CloudImageComponent;



// WEBPACK FOOTER //
// ./src/components/ui/CloudImageComponent.js